import React from 'react';
import { Checkbox } from 'antd';

export const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
    showOnEdit: true,
    type: 'number',
    editable: false,
    creatable: false,
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    showOnEdit: true,
    type: 'string',
    editable: true,
    creatable: true,
  },
  {
    title: 'Default display order',
    dataIndex: 'defaultDisplayOrder',
    key: 'defaultDisplayOrder',
    sorter: (a, b) =>
      Number(a.defaultDisplayOrder) - Number(b.defaultDisplayOrder),
    showOnEdit: true,
    type: 'number',
    editable: true,
    creatable: true,
  },
  {
    title: 'is Display Order Fixed',
    dataIndex: 'isDisplayOrderFixed',
    key: 'isDisplayOrderFixed',
    render: (value) => <Checkbox checked={value} />,
    showOnEdit: true,
    type: 'boolean',
    editable: true,
    creatable: true,
  },
  {
    title: 'Inactive Ind',
    dataIndex: 'inactiveInd',
    key: 'inactiveind',
    render: (value) => <Checkbox checked={value} />,
    showOnEdit: true,
    type: 'boolean',
    editable: true,
    creatable: true,
  },
];

export const extraColumns = [];
